/**
 * Deletes the entry from IME entry detail page.
 */
export function deleteEntry() {
	const $entryContainer = $( '.o__ime-form-entry' );
	if ( !$entryContainer.length ) {
		return;
	}

	const entryId = $entryContainer.data( 'entry-id' );
	const action = $entryContainer.data( 'delete-action' );
	const redirect = $entryContainer.data( 'delete-redirect' );

	$( '.confirm-cancel-button' ).on( 'click', function onDelete() {
		const data = {
			action,
			entryId,
			redirect,
		};
		$( document ).trigger( 'deleteEntry', data );
	});
}